import React from 'react';
import MoviePage from './movies/MoviePage';


function App() {
  return (
    <div className="App">
      <MoviePage />
    </div>
  );
}

export default App;
